import React from "react";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import HeroSection from "../../../components/HeroSection/HeroSection";
import HeroCaption from "../../../components/HeroCaption/HeroCaption";

import FacultyResponsive from "../../../components/FacultyResponsive/FacultyResponsive";
import CoursesResponsive from "../../../components/CoursesResponsive/CoursesResponsive";
import DepartmentInfoResponsive from "../../../components/DepartmentInfoResponsive/DepartmentInfoResponsive";
import DepartmentAboutInfoResponsive from "../../../components/DepartmentAboutInfoResponsive/DepartmentAboutInfoResponsive";
import HODResponsive from "../../../components/HODResponsive/HODResponsive";

const hodData = {
  imageUrl: require("../../../assets/hod-images/CS HOD.png"),
  designation: "Head of the Department",
  name: "Nihar Ranjan Panda",
  feedback: `Dear Students,

Welcome to the Department of Master of Computer Applications (MCA) at NIET. As the Head of the Department, I am delighted to introduce you to a dynamic and future-focused learning environment.

Our MCA program is designed to equip students with strong theoretical foundations and hands-on technical skills in computer science and applications. We focus on areas such as software development, data structures, algorithms, database management, cloud computing, cybersecurity, AI, and machine learning — all critical in the evolving tech landscape.

Our faculty comprises experienced academicians and industry professionals who are committed to mentoring you through a rigorous and industry-relevant curriculum. We foster a culture of innovation, critical thinking, and continuous learning through live projects, internships, workshops, and hackathons.

The department is well-equipped with modern laboratories and computing resources that help bridge the gap between academic concepts and real-world application. Additionally, we organize seminars, coding competitions, and tech fests to encourage all-round development.

We are confident that the skills and knowledge you gain here will empower you to become successful software professionals, IT managers, entrepreneurs, and researchers.

Wishing you an enriching and successful academic journey ahead.

Sincerely,

Prof. Name
`,
};

const BasicSciencesPage = () => {
  return (
    <PageWrapper className="mt-n6">
      <HeroSection className="bg-page-background-7">
        <HeroCaption
          title="Master of Computer Applications (MCA)"
          position="bottom-left"
          breadcrumb={true}
          breadcrumbPrefix="Home"
        />
      </HeroSection>

      <DepartmentInfoResponsive
        title={"Master of Computer Applications"}
        desc={`The MCA Department at NIET offers a postgraduate program that prepares students for a successful career in the IT industry. The curriculum is designed to build a strong foundation in computer science while also focusing on modern tools and technologies required in today’s software landscape. Students gain expertise in software development, data analytics, web technologies, mobile app development, cloud computing, and cybersecurity.`}
      />

      <HODResponsive hodData={hodData} />

      <DepartmentAboutInfoResponsive
        title={"About the Department"}
        desc={`The Department of Master of Computer Applications at NIET provides a comprehensive and industry-aligned curriculum that empowers students with strong problem-solving and technical skills. The department emphasizes both theoretical learning and practical implementation in areas like programming, software engineering, database systems, cloud infrastructure, and artificial intelligence.

We maintain well-equipped labs, smart classrooms, and a collaborative environment that supports research, innovation, and entrepreneurship. Our faculty members bring a rich mix of academic knowledge and industry experience, ensuring students are well-prepared for real-world challenges.

Students are encouraged to engage in live projects, technical fests, coding contests, and internships with top IT companies. The department also offers career guidance, placement support, and soft skill training to help students excel in competitive job markets.

We aim to produce competent and innovative tech professionals who can contribute effectively to the software industry and research sectors.`}
      />
    </PageWrapper>
  );
};

export default BasicSciencesPage;
